import { createStore, applyMiddleware, combineReducers } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'

import { customers } from './api/customers/reducers'
import { customerPayers } from './api/customers/reducers'
import { companyDetails } from './api/company-details/reducers'
import { offers, tilbod, agentOffers, customerOffers } from './api/offers/reducers'
import { gui } from './api/gui/reducers'
import { currency } from './api/currency/reducers'
import { infoCollection } from './api/information-collection/reducers'
import { nationalRegistry, nationalRegistryNamespaced } from './api/national-registry/reducers'
import { virtualCard } from './api/virtual-card/reducers'
import { contracts } from './api/contracts/reducers'
import { agentCases, caseDetails } from './api/cases/reducers'
import { olderDeclarations } from './api/older-declarations/reducers'
import { electronicPublication } from './api/electronic-publications/reducers'
import { employerDeclaration } from './api/employer-declaration/reducers'
import { employerAccess } from './api/employer-access/reducers'
import { healthQuestions } from './api/health-questions/reducers'
import { payers } from './api/payers/reducers'
import { employers } from './api/employers/reducers'
import { jobs } from './api/jobs/reducers'
import { tooltips } from './api/tooltips/reducers'
import { fundTable } from './api/fund-table/reducers'
import { countries } from './api/countries/reducers'
import { brokers, admins } from './api/brokers/reducers'
import { insuranceTakers } from './api/insurance-takers/reducers'
import { paymentApplications } from './api/payment-applications/reducers'
import { identification } from './api/id/reducers'
import { signingRecords } from './api/signing-records/reducers'
import { additionalAxDocuments } from './api/signing-records/reducers'
import { questionnaires } from './api/questionnaires/reducers'
import { VIDPartialContract, VIDTPartialContract } from './api/vid-percentage/reducers'

import { composeWithDevTools } from 'redux-devtools-extension';

//import TokenStorage from './storages/token-storage'

const loggerMiddleware = createLogger()

const reducers = combineReducers({
    customers,
    customerPayers,
    companyDetails,
    offers,
    gui,
    infoCollection,
    nationalRegistry,
    currency,
    virtualCard,
    contracts,
    agentCases,
    caseDetails,
    olderDeclarations,
    electronicPublication,
    employerDeclaration,
    employerAccess,
    healthQuestions,
    payers,
    employers,
    jobs,
    fundTable,
    countries,
    brokers,
    admins,
    insuranceTakers,
    nationalRegistryNamespaced,
    paymentApplications,
    signingRecords,
    additionalAxDocuments,
    tilbod,
    VIDPartialContract,
    VIDTPartialContract,
    agentOffers,
    customerOffers,
    tooltips,
    questionnaires,
    identification
})


let middleware = null
if(process.env.NODE_ENV === 'production') {
    middleware = applyMiddleware(
        thunkMiddleware
    )
} else {
    middleware = applyMiddleware(
        thunkMiddleware
    )

    // middleware = composeWithDevTools(applyMiddleware(
    //     thunkMiddleware,
    //     loggerMiddleware
    // ))
}

export const store = createStore(reducers, middleware)


// const token = TokenStorage.getItem('token');
// if (token !== null) {
//     store.dispatch(userLoginSuccess(token));
// }